import(/* webpackMode: "eager", webpackExports: ["GalleryClient"] */ "/opt/buildhome/repo/app/(main)/gallery/GalleryClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
